import { SelectProps } from 'antd';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';

import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import {
  useSupplierReducedMutation,
  useSuppliersReduce,
} from '@/core/domain/people/Suppliers/Suppliers.hooks';
import useSelectOptions from '@/hooks/useSelectOptions';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListSuppliersQuery;
  queryEnable?: boolean;
};

const SupplierSelect: React.FC<Props> = ({
  queryFilter,
  queryEnable = false,
  ...props
}) => {
  const [selectClicked, setSelectClicked] = useState<boolean>(queryEnable);
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const supplierList = useSuppliersReduce(
    {
      ...queryFilter,
      active: true,
      rows: 10,
      name: search,
    },
    (queryEnable || selectClicked) && !props.disabled,
  );
  const supplierReduced = useSupplierReducedMutation();

  const options = useSelectOptions({
    list: supplierList,
    detail: supplierReduced,
    selectProps: props,
    labelFormatter: (supplier) => supplier.name,
  });

  return (
    <InfiniteSelect
      fetchNextPage={supplierList.fetchNextPage}
      hasNextPage={supplierList.hasNextPage}
      loading={supplierList.isFetching}
      options={options}
      onSelect={() => setSelectClicked(false)}
      onDropdownVisibleChange={(open) => setSelectClicked(open)}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default SupplierSelect;
